/* Magic Milk - zwei Dinge:
   1) FAQ auf der Startseite NUR optisch umgebaut, Inhalte unangetastet.
      Sternify-Aufbau: .st_faq-wrapper > .st_faq-right-column > .st_faq-item
      > button.st_faq-question + div.st_faq-answer
   2) Klappfelder auf der Produktseite, als eigener Block ERGAENZT (nichts ersetzt).
      Texte knapp und belegbar; Details stehen auf den verlinkten Rechtsseiten. */
(function () {
  var K = 'cubic-bezier(.22,.61,.36,1)';
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = [
    '.st_faq-wrapper{background:#0E0B0D!important;border-radius:20px;',
      'border:1px solid rgba(243,233,236,.08);',
      'padding:clamp(20px,4vw,42px) clamp(15px,3vw,36px)!important}',
    '.st_faq-wrapper h2,.st_faq-wrapper h3{color:#F3E9EC!important;letter-spacing:-.02em}',
    '.st_faq-item{background:transparent!important;border:0!important;',
      'border-bottom:1px solid rgba(243,233,236,.13)!important;border-radius:0!important;',
      'box-shadow:none!important;margin:0!important;padding:0!important}',
    '.st_faq-item:last-child{border-bottom:0!important}',
    'button.st_faq-question{display:flex!important;width:100%;align-items:center;',
      'justify-content:space-between;gap:18px;text-align:left;',
      'background:transparent!important;border:0!important;border-radius:0!important;',
      'box-shadow:none!important;cursor:pointer;',
      'padding:clamp(16px,2.4vw,22px) 0!important;',
      'font-size:clamp(1rem,1.9vw,1.3rem)!important;font-weight:600!important;',
      'line-height:1.32!important;color:#F3E9EC!important;transition:opacity .25s ease}',
    '@media (hover:hover){button.st_faq-question:hover{opacity:.72}}',
    'button.st_faq-question:focus-visible{outline:2px solid #FF4B7E;outline-offset:3px}',
    'button.st_faq-question::after{content:"";flex:none;width:9px;height:9px;',
      'border-right:2px solid rgba(243,233,236,.55);',
      'border-bottom:2px solid rgba(243,233,236,.55);',
      'transform:rotate(45deg) translate(-2px,-2px);',
      'transition:transform .32s ' + K + ',border-color .25s ease}',
    'button.st_faq-question[aria-expanded="true"]::after,',
    '.st_faq-item.open button.st_faq-question::after,',
    '.st_faq-item.active button.st_faq-question::after{',
      'transform:rotate(225deg) translate(-2px,-2px);border-color:#FF4B7E}',
    '.st_faq-answer{color:rgba(243,233,236,.62)!important;',
      'font-size:clamp(.94rem,1.5vw,1.02rem)!important;line-height:1.65!important;',
      'background:transparent!important;border:0!important;',
      'padding:0 0 clamp(16px,2.2vw,22px)!important}',
    '.st_faq-answer a{color:#FF4B7E!important;text-decoration:underline}',

    '#mmPK{margin:30px 0 6px;border-top:1px solid rgba(0,0,0,.12)}',
    '#mmPK details{border-bottom:1px solid rgba(0,0,0,.12)}',
    '#mmPK summary{list-style:none;cursor:pointer;display:flex;align-items:center;',
      'justify-content:space-between;gap:16px;padding:17px 0;',
      'font-size:1rem;font-weight:600;line-height:1.35;transition:opacity .22s ease}',
    '#mmPK summary::-webkit-details-marker{display:none}',
    '@media (hover:hover){#mmPK summary:hover{opacity:.66}}',
    '#mmPK summary:focus-visible{outline:2px solid #E5142A;outline-offset:3px}',
    '#mmPK summary::after{content:"";flex:none;width:8px;height:8px;',
      'border-right:2px solid currentColor;border-bottom:2px solid currentColor;',
      'opacity:.5;transform:rotate(45deg) translate(-2px,-2px);',
      'transition:transform .3s ' + K + ',opacity .25s ease}',
    '#mmPK details[open] summary::after{transform:rotate(225deg) translate(-2px,-2px);',
      'opacity:1;color:#E5142A}',
    '#mmPK .mmPKinhalt{padding:0 0 20px;font-size:.95rem;line-height:1.62;opacity:.82}',
    '#mmPK .mmPKinhalt p{margin:0 0 10px}',
    '#mmPK .mmPKinhalt p:last-child{margin-bottom:0}',
    '#mmPK .mmPKinhalt a{color:#E5142A;text-decoration:underline}',
    '#mmPK .mmPKinhalt ul{margin:0 0 10px;padding-left:20px}',
    '#mmPK .mmPKinhalt li{margin-bottom:5px}',
    '#mmPK details[open] .mmPKinhalt{animation:mmPKauf .34s ' + K + ' both}',
    '@keyframes mmPKauf{from{opacity:0;transform:translateY(-6px)}',
      'to{opacity:.82;transform:none}}',
    '@media (prefers-reduced-motion:reduce){',
      '#mmPK details[open] .mmPKinhalt{animation:none}}'
  ].join('');

  function stil() {
    if (document.getElementById('mmFaq-stil')) return;
    var st = document.createElement('style');
    st.id = 'mmFaq-stil';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function produktKlappfelder() {
    if (!/^\/products\//.test(window.location.pathname)) return true;
    if (document.getElementById('mmPK')) return true;

    var knopf = document.querySelector('button[name="add"], .shopify-payment-button');
    if (!knopf) return false;
    var anker = knopf.closest('product-form, .product-form, form[action*="/cart/add"]') || knopf;
    if (!anker.parentNode) return false;

    stil();

    /* 22.08.2026, Mert: "raus mit 1.bild und reinsetzen sauber in produkt
       angaben / rueckgabe und wiederruf raus."
       Das Theme hatte zwei eigene Aufklapper - "Zutaten und Anwendung" und
       "Zusaetzliche Informationen". Deren Inhalt ist PFLICHTANGABE bei
       Nahrungsergaenzung (Anwendung, Zutaten, Allergene, Schwangerschaft), er
       wird also nicht geloescht, sondern hier sauber zusammengefasst; die zwei
       Kaesten selbst blendet `themenKastenWeg()` unten aus.
       "Rueckgabe und Widerruf" ist auf Merts Wort ganz raus - die
       Widerrufsbelehrung steht weiterhin in der Fusszeile und im Checkout. */
    var felder = [
      ['Produktangaben',
        /* 22.08.2026 KORRIGIERT: Hier stand "30 Einzelsachets a 5 g". Der
           amtliche Pruefbericht 2026-5600117 des CVUA Rhein-Ruhr-Wupper weist
           fuer die entnommene Probe **30 x 4 g = 120 g** aus. Vier Gramm, nicht
           fuenf. Die Nettofuellmenge fehlte auf der Seite ganz - genau das
           hatte die Behoerde beanstandet (Art. 9 Abs. 1 VO (EU) 1169/2011). */
        '<ul>' +
          '<li><b>Nettof\u00fcllmenge 120 g</b> je Packung \u2013 30 Sticks \u00e0 4 g, ' +
            'Vorrat f\u00fcr einen Monat</li>' +
          '<li>Ein Stick t\u00e4glich in 200\u2013250 ml lauwarmem Wasser oder ' +
            'lauwarmer Milch einr\u00fchren, gut umr\u00fchren, langsam trinken</li>' +
          '<li>Am besten morgens vor der ersten Mahlzeit</li>' +
          '<li>Die empfohlene t\u00e4gliche Verzehrmenge nicht \u00fcberschreiten</li>' +
        '</ul>' +
        /* Art. 21 VO (EU) 1169/2011 verlangt, dass allergene Zutaten im
           Zutatenverzeichnis HERVORGEHOBEN werden - durch Schriftart, Stil oder
           Hintergrund. Genau das fehlte laut Pruefbericht. Milchpulver und
           Weizenkeime stehen deshalb jetzt fett. */
        '<p><b>Zutaten laut Herstellerangaben:</b> Ingwer, ' +
        '<b>Milchpulver</b>, <b>Weizenkeime</b>, Bockshornklee, Distel, ' +
        'L\u00f6wenzahn, Kreuzk\u00fcmmel, Zitrusschalen, Kamille und Zimt. ' +
        'Ma\u00dfgeblich sind immer die Angaben auf der Verpackung der ' +
        'jeweiligen Charge.</p>' +
        '<p><b>Allergene:</b> Enth\u00e4lt <b>Milch</b> und <b>Weizen (Gluten)</b>. ' +
        'Das Produkt kann Kr\u00e4uter, Gew\u00fcrze und weitere ' +
        'Pflanzenbestandteile enthalten.</p>' +
        '<p><b>Wichtige Hinweise:</b> Nahrungserg\u00e4nzungsmittel \u2013 kein ' +
        'Arzneimittel und kein Ersatz f\u00fcr eine ausgewogene Ern\u00e4hrung. ' +
        'F\u00fcr Erwachsene bestimmt. Personen mit Allergien, Unvertr\u00e4glich' +
        'keiten, Vorerkrankungen oder w\u00e4hrend Schwangerschaft und Stillzeit ' +
        'sollten vor der Anwendung \u00e4rztlichen Rat einholen. K\u00fchl, trocken ' +
        'und lichtgesch\u00fctzt lagern.</p>' +
        '<p>Vollst\u00e4ndige Angaben unter ' +
        '<a href="/pages/inhaltsstoffe-anwendung-risiken-und-wichtige-hinweise">Inhaltsstoffe &amp; ' +
        'Sicherheitshinweise</a>.</p>'],
      ['Versand',
        '<p>Versand aus Deutschland. Lieferung nach Deutschland, \u00d6sterreich und ' +
        'in die Schweiz, als Standard- oder Expressversand.</p>' +
        '<p>Kosten, Laufzeiten und L\u00e4nder stehen in den ' +
        '<a href="/policies/shipping-policy">Versandbedingungen</a>. ' +
        'Deine Sendung verfolgst du unter <a href="/a/track">Track order</a>.</p>']
    ];

    var box = document.createElement('div');
    box.id = 'mmPK';
    box.innerHTML = felder.map(function (f, i) {
      /* 24.08.2026, Mert: "halte das zugeklappt" - Produktangaben startet
         jetzt wie die anderen Felder eingeklappt, nicht offen. */
      return '<details>' +
               '<summary>' + f[0] + '</summary>' +
               '<div class="mmPKinhalt">' + f[1] + '</div>' +
             '</details>';
    }).join('');

    anker.parentNode.insertBefore(box, anker.nextSibling);
    themenKastenWeg();
    return true;
  }

  /* Blendet die zwei Aufklapper des Themes aus, deren Inhalt jetzt oben in
     "Produktangaben" steht. Gesucht wird ueber den TEXT der Kopfzeile, nicht
     ueber eine Klasse - Klassennamen aendern sich beim naechsten Theme-Update,
     die Ueberschrift nicht. Mehrfach nachziehen, weil das Theme die Kaesten
     teils spaeter nachschiebt. */
  function themenKastenWeg() {
    var TITEL = /^(Zutaten und Anwendung|Zus\u00e4tzliche Informationen)$/i;
    function raeumen() {
      var kandidaten = document.querySelectorAll('summary, .accordion__title, ' +
        '[class*="accordion"] button, [class*="collapsible"] button, h3, h4');
      [].forEach.call(kandidaten, function (k) {
        var t = (k.textContent || '').replace(/\s+/g, ' ').trim();
        if (!TITEL.test(t)) return;
        var kasten = k.closest('details, .accordion, [class*="accordion"], ' +
          '[class*="collapsible"]') || k.parentElement;
        if (kasten && kasten.id !== 'mmPK' && !kasten.closest('#mmPK')) {
          kasten.style.setProperty('display', 'none', 'important');
        }
      });
    }
    raeumen();
    [300, 900, 2000, 4000].forEach(function (ms) { setTimeout(raeumen, ms); });
  }

  function aufbauen(antwort) {
    if (ruhig || antwort.dataset.mmF) return;
    antwort.dataset.mmF = '1';
    var zeichen = [], knoten = [], n;
    var lauf = document.createTreeWalker(antwort, NodeFilter.SHOW_TEXT);
    while ((n = lauf.nextNode())) { if (n.textContent.trim() !== '') knoten.push(n); }
    if (!knoten.length || knoten.length > 40) return;
    knoten.forEach(function (kn) {
      var frag = document.createDocumentFragment();
      kn.textContent.split('').forEach(function (c) {
        var s = document.createElement('span');
        s.textContent = c;
        s.style.cssText = 'display:inline-block;opacity:0;filter:blur(9px);' +
          'transition:opacity .3s ease,filter .3s ease';
        frag.appendChild(s); zeichen.push(s);
      });
      if (kn.parentNode) kn.parentNode.replaceChild(frag, kn);
    });
    function zeig(z) { z.style.opacity = '1'; z.style.filter = 'blur(0)'; }
    if (zeichen.length > 900) { zeichen.forEach(zeig); return; }
    zeichen.forEach(function (z, i) { setTimeout(function () { zeig(z); }, i * 12); });
    setTimeout(function () { zeichen.forEach(zeig); }, 4000);
  }

  function anbinden() {
    var fragen = document.querySelectorAll('button.st_faq-question');
    if (fragen.length) {
      stil();
      [].forEach.call(fragen, function (f) {
        if (f.dataset.mmA) return;
        f.dataset.mmA = '1';
        f.addEventListener('click', function () {
          var item = f.closest('.st_faq-item');
          var antwort = item && item.querySelector('.st_faq-answer');
          if (antwort) setTimeout(function () { aufbauen(antwort); }, 60);
        });
      });
    }
    var pk = produktKlappfelder();
    return fragen.length > 0 || (pk && document.getElementById('mmPK'));
  }

  function versuchen() {
    if (anbinden()) return;
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (anbinden() || n > 14) clearInterval(t);
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else { versuchen(); }
  window.addEventListener('load', versuchen);
})();
